module.exports = __webpack_public_path__ + "img/maigret-duda.240fa57c.jpg";